import { useFetch } from '@llt-frontend/react-fetch';

// Constants
// ---------

const USER_API_PATH = `${process.env.REACT_APP_API_HOST}/vtwa/v2/users/me`;

// Exports
// -------

export default function useUser() {
  const response = useFetch(USER_API_PATH);

  //
  // Result

  // This will be undefined when no error has occurred and will provide a falsy value to check against.
  let isError = response.error;
  if (!response.data?.client_id && response.status === 'success') {
    isError = Error('Unable to load user info');
  }

  return {
    isError,
    isLoading: response.status === 'loading',
    data: response.data,
  };
}
